import React, { useEffect, useState } from 'react'
import PageHeader from '../../shared/page-header/PageHeader';
import TitleModal from './TitleModal';
import TitleGrid from './TitleGrid';
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import { logAuditEvent } from '../../utils/auditLogger';

function TitleMain(props) {
  const [titleList, setTitleList] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [alert, setAlert] = useState(null);
  const [getUserModulePermission, setUserModulePermission] = React.useState([]);
  const moduleName = props.Module || 'Titles';
  
  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchTitles();
  }, []);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Titles');
  }, [moduleName]);

  function openAddModal() {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add title modal');
  }
  function closeModal() {
    setIsOpen(false);
  }
  async function onSubmit(e, data) {
    if (e.target.name === "Add") {
      const model = data;
      if(model){
        logAuditEvent(moduleName, 'Save Title Attempt', model.Title || 'New title');
        let titleDetails = {
          TitleId: null,
          Title: model.Title ? model.Title : "",
          Description: model.Description ? model.Description : "",
          UserId: getStorageValues('userId')
        };
        if (validation(titleDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saveTitle",
              titleDetails
            );
            if (response.status === 200) {
              if(response.data.data[0].success === 1){
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'Title Saved', response.data.data[0].message || 'Success');
                fetchTitles();
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            } 
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'Title Save Failed', error.message || 'Unknown error');
          }
        }
      } else {
        CreateAlert("Fields marked with an asterisk (*) are required!!", "Error", setAlert);
      }
    } 
  }
  function validation(titleDetails) {
    var validation = true;
    if (titleDetails) {
      if (titleDetails.Title !== null | undefined) {
        if (titleDetails.Title.length === 0) {
          CreateAlert("Please enter title!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter title!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }
  const fetchTitles = async () => {
    try {
      let dummy = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/titlelist", dummy);
      if (response.status === 200) {
        setTitleList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleRefresh = () => {
    logAuditEvent(moduleName, 'Refresh Click', 'Refreshed titles');
    fetchTitles();
  };
  const handleExportExcel = () => {
    const columns = [
      { name: "Title", selector: "Title" },
      { name: "Description", selector: "Description" },
    ];
    exportToExcel("Titles", columns, titleList);
    logAuditEvent(moduleName, 'Export Excel', `Rows=${titleList.length}`);
  };
  
  const handleExportPDF = () => {
    const columns = [
      { name: "Title", selector: "Title" },
      { name: "Description", selector: "Description" },
    ];
    exportToPDF("Titles", columns, titleList);
    logAuditEvent(moduleName, 'Export PDF', `Rows=${titleList.length}`);
  };
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal} 
        onRefresh={handleRefresh}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={getUserModulePermission.AddModule === 1 ? true : false}
      />
      <TitleGrid TitleData={titleList} fetchTitles={fetchTitles} UserPermissions={getUserModulePermission}/>
      <TitleModal
        show={modalIsOpen}
        UserAction={"Add"}
        onClose={closeModal}
        onSubmit={onSubmit}

      />
    </>
  )
}

export default TitleMain